import { render, staticRenderFns } from "./SalesControl.vue?vue&type=template&id=068b9df8&"
import script from "./SalesControl.vue?vue&type=script&lang=js&"
export * from "./SalesControl.vue?vue&type=script&lang=js&"
import style0 from "./SalesControl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports